<script setup>
import {computed} from "vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import useUser from "@/composables/useUser";
import {isOnLocalDomain} from "@/composables/useLocalDomains";
import {kitName} from "@/composables/useLocalDomains";

const {isSubscribedToKit} = useUser();

const props = defineProps({
  autoFixed: {
    type: Boolean,
    default: false,
  },
});

const isAutoFixed = computed(() => !!props.autoFixed);
</script>

<template>
  <VTooltip
    placement="bottom"
    theme="dark-blue-tooltip"
    :delay="{ show: 0, hide: 1000 }"
  >
    <KitIcon class="tw-w-8" />

    <template #popper>
      <div
        v-if="isAutoFixed"
        class="tw-whitespace-normal"
      >
        <strong>Completed automatically by {{ kitName }}.</strong>
        <br>
        {{ kitName }} handled this as part of your monthly SEO tasks.
      </div>
      <div
        v-else-if="isSubscribedToKit"
        class="tw-whitespace-normal"
      >
        <strong>This action can be completed by {{ kitName }}.</strong>
        <br>
        {{ kitName }} will complete this when it reaches this page as part of its optimization process.
      </div>
      <div
        v-else
        class="tw-whitespace-normal"
      >
        <strong>This action is one that {{ kitName }}, the AI SEO assistant, can complete for you.</strong>
        <br>
        {{ kitName }} helps with selected SEO actions like this to save you time and improve your visibility.
        <br>

        <a
          v-if="isOnLocalDomain"
          href="/dash"
          target="_blank"
          class="tw-text-blue-400 tw-underline hover:tw-text-blue-300"
        >
          Learn more about {{ kitName }} →
        </a>
      </div>
    </template>
  </VTooltip>
</template>
